import { defineComponent } from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
export default defineComponent({
    name: 'payment-type-selection',
    methods: Object.assign(Object.assign({}, mapActions('blue', {
        registerPayment: 'SET_PAYMENT_TYPE',
    })), { sendeZahlungsart(payment_type) {
            if (payment_type.disabled) {
                return;
            }
            this.registerPayment(payment_type.id);
        } }),
    computed: Object.assign(Object.assign({}, mapGetters('blue', { currentPaymentType: 'currentPaymentType' })), mapState('blue', { payment_types: 'payment_types' })),
});
